import { Tooltip as TTip, withStyles } from '@material-ui/core';

// @ts-ignore
export const Tooltip = withStyles(() => ({
	arrow: {
		color: '#222',
	},
	tooltip: {
		lineHeight: '1.6em',
		backgroundColor: '#222',
		color: '#fff',
		fontWeight: '500',
		fontSize: '0.8rem',
		wordWrap: 'break-word',
		borderRadius: '16px',
		textAligin: 'center',
		padding: '8px 12px',
	},
}))(TTip);
